export const appRoutes = {
  HOME_PAGE: "/",

  AUTH: "/auth",
  AUTH_LOGIN_PAGE: "/auth/login",
  AUTH_REGISTER_PAGE: "/auth/register",
  // Password recovery. Both live under /auth so they inherit AuthLayout —
  // the same card, logo and language switch the login page uses.
  AUTH_FORGOT_PASSWORD_PAGE: "/auth/forgot-password",
  // The token is in the PATH because that is what an email client will
  // linkify reliably; a query string is mangled by more of them.
  AUTH_RESET_PASSWORD_PAGE: "/auth/reset-password/:token",
  // Confirming a new email address. Under /auth like the reset page, and for
  // the same reason: the link is opened from a mail client with no session.
  // Selector and token are separate path segments, matching the mail's URL.
  AUTH_CONFIRM_EMAIL_PAGE: "/auth/confirm-email/:selector/:token",
  AUTH_LOGOUT: "/logout",

  ERROR: "/errors",
  ERROR_PAGE_401: "/errors/error-401",
  ERROR_PAGE_404: "/errors/error-404",
  ERROR_PAGE_500: "/errors/error-500",

  PAGES: "/pages",
  PAGE_TERMS_AND_CONDITIONS: "/pages/terms-and-conditions",

  // The whole audit trail, SUPER-ADMIN only. Top level rather than a tab in
  // Competition Settings: it is about the system, not about a competition.
  AUDIT_LOG_PAGE: '/audit-log',
  PROFILE_DUPLICATES_PAGE: '/profile-duplicates',

  ACCOUNT_PAGE: '/account',
  ACCOUNT_PAGE_TAB: "/account/:tab",

  APPLICATIONS_PAGE: '/applications',
  COMPETITIONS_PAGE: '/competitions',
  COMPETITION_DETAIL_PAGE: '/competitions/:competitionId',
  // Competition-SCOPED configuration — THE one editable location for
  // execution format / draw strategy / competition level. Distinct from
  // COMPETITION_SETTINGS_PAGE below, the unrelated GLOBAL config area
  // (rules/clubs/etc.), which hosts no configuration editor.
  COMPETITION_CONFIGURATION_PAGE: '/competitions/:competitionId/settings',
  // Every report of ONE competition, and its blank forms.
  COMPETITION_REPORTS_PAGE: '/competitions/:competitionId/reports',
  // «Мої татамі» — the mats the signed-in secretary is assigned to.
  MY_TATAMIS_PAGE: '/my-tatamis',
  // Competition Operations. The floor is the chief secretary's view of every
  // mat; the workspace is ONE mat, addressed the way the floor is spoken
  // about — day and tatami number, not an opaque session id.
  COMPETITION_OPERATIONS_PAGE: '/competitions/:competitionId/operations',
  // Screens and phones of one competition, by mat (6 Oct 2026) — moved off
  // the live floor, where ten of each buried the mats.
  COMPETITION_DEVICES_PAGE: '/competitions/:competitionId/devices',
  // The participants' monitor of one competition — how names are shown and
  // the QR codes printed for the hall (29 Oct 2026).
  COMPETITION_MONITOR_PAGE: '/competitions/:competitionId/monitor',
  TATAMI_WORKSPACE_PAGE: '/competitions/:competitionId/tatamis/:day/:tatamiNumber/workspace',
  // Public TV. Deliberately OUTSIDE the competition path and outside the
  // authenticated layout: a screen boots from this URL alone, with no login
  // and no navigation.
  // The ONE url a kiosk opens. No token, no mat, no competition — the device
  // pairs itself, so a single SD card image serves every screen in a venue.
  DISPLAY_PAIRING_PAGE: '/display',
  PUBLIC_DISPLAY_PAGE: '/display/:token',
  // A PHONE AT THE MAT (6 Oct 2026): pairs like a screen — one url, a code,
  // the chief secretary names the mat — then runs that mat's kumite bout.
  MAT_PHONE_PAIRING_PAGE: '/mat-phone',
  // No token in it: the phone keeps that in storage (7 Oct 2026).
  MAT_PHONE_PAGE: '/mat-phone/bout',
  // THE PARTICIPANTS' MONITOR (29 Oct 2026): what the QR code at the hall's
  // entrance opens. Short on purpose — it is printed. Layout-free and public,
  // like the display: the token is the whole credential.
  PARTICIPANT_MONITOR_PAGE: '/m/:token',
  // THE PUBLISHED SCHEDULE (29 Oct 2026): what the chief secretary published,
  // for anybody with the link — layout-free and public like /m/.
  PUBLIC_SCHEDULE_PAGE: '/s/:competitionId',
  COMPETITION_SETTINGS_PAGE: '/competition-settings',

  COMPETITION_SETTINGS_PAGE_TAB: "/competition-settings/:tab",

  PROFILES_PAGE: '/profiles',

  SPORTSMEN_PAGE: '/sportsmen',

  SCHEDULE_PAGE: '/schedule/:competitionId',

  SHOOTING_PAGE: '/shooting/:competitionId',

  ATTENDANCE_PAGE: '/competitions/:competitionId/attendance',
  // Kept only as a redirect target — do not maintain a second implementation.
  LEGACY_ATTENDANCE_PAGE: '/attendance/:competitionId',

  MSAC_FINAL_PAGE: '/msac-final/:competitionId',
};
